import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-circle"><circle cx="12" cy="12" r="10" fill="currentColor"/></CentralIconBase>;
};

export default IconFormCircle;
